import { useSelector } from "react-redux";
import { ApplicationState } from "..";

export const useAffectedTypeReducer = () => useSelector((state: ApplicationState) => state.affectedType);
